import React from 'react'

const Google = ({ size = 24, color = '#3076D0', ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<path
			d="M12.1831 2.75C8.50007 2.75 5.28107 4.781 3.76407 7.838C3.09777 9.12434 2.75 10.5518 2.75 12.0005C2.75 13.4492 3.09777 14.8767 3.76407 16.163C5.28107 19.219 8.50007 21.25 12.1831 21.25C14.7231 21.25 16.9031 20.423 18.4271 19.026C20.9111 16.853 21.6121 13.427 21.0851 10.338C21.0752 10.2799 21.0451 10.2272 21 10.1891C20.955 10.151 20.898 10.1301 20.8391 10.13H12.1831C12.1168 10.13 12.0532 10.1563 12.0063 10.2032C11.9594 10.2501 11.9331 10.3137 11.9331 10.38V13.71C11.9331 13.848 12.0451 13.96 12.1831 13.96H16.9511C16.7851 14.7 16.2641 15.707 15.2661 16.383L15.2581 16.388C14.5731 16.89 13.5231 17.24 12.1831 17.24C9.24708 17.24 6.90807 14.785 6.90807 11.91C6.90807 9.127 9.38007 6.67 12.1831 6.67C13.8531 6.67 14.9031 7.353 15.6121 7.96C15.6595 8.00055 15.7204 8.0219 15.7827 8.01986C15.8451 8.01783 15.9044 7.99255 15.9491 7.949L18.5271 5.429C18.5518 5.40483 18.5713 5.37578 18.5843 5.3437C18.5973 5.31161 18.6034 5.27718 18.6024 5.24258C18.6013 5.20799 18.5931 5.17399 18.5783 5.14273C18.5634 5.11148 18.5422 5.08364 18.5161 5.061C16.9071 3.673 14.7321 2.75 12.1831 2.75Z"
			fill={color}
		/>
	</svg>
)

export default Google;
